import { createApp, type Component } from 'vue';

export const lazyCreateApp = (rootContainer: HTMLElement, rootComponent: Component, rootProps?: { [x: string]: unknown }) => {
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          createApp(rootComponent, rootProps).mount(rootContainer);
          observer.unobserve(rootContainer);
        }
      });
    });
    observer.observe(rootContainer);
  }
};
